// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__30sSL","footer":"ModalUpdate_footer__2Bx86"};